import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {APP} from "../../app/consts";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";

export class SearchBarClickEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;

  constructor(source: APP.ANALYTICS.SOURCES) {
    super('', 'click', 'search-bar');

    this.source = source;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = this.resolveEventName();
    return new GoogleAnalyticsEventModel(eventName, {
      placement: this.source
    })
  }
}
